import React from 'react'
import { Router } from 'react-router'

interface Props {
  router: Router
}

const defaultState = {
  router: null
}

// `router` will never be `null`, it will equal to instance of react-router
// @ts-ignore
export default React.createContext<Props>(defaultState)
